import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { omit, pick } from 'lodash';

/**
 * ListTrustedValueHistory
 *
 * Retrieves a list of trusted record changes related to an eid from the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const ListTrustedValueHistory = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = omit(payload?.[2], ['page', 'size', 'sort']);
    const thePagination = pick(payload?.[2], ['page', 'size', 'sort']);

    const requestArgs = {
      baseURL: config('API_URL'),
      data: thePayload,
      headers: {
        'x-api-endpoint': `/risk-records/${thePayload?.eid}/trusted-record-change`,
      },
      method: 'POST',
      params: { ...{ apiKey: theApiKey, queryKey: theQueryKey }, ...thePagination },
    };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/RiskRecord/api/requests/queries/ListTrustedValueHistory.js -> ListTrustedValueHistory()',
      false,
      error
    );

    throw error;
  }
};
